import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	createPdfReference,
	type CreatePdfReferenceRequest,
	type CreatePdfReferenceResponse,
} from '../../http/selfEmployment/createPdfReference';

export function useCreatePdfReference(
	options?: UseMutationOptions<CreatePdfReferenceResponse, AxiosError, CreatePdfReferenceRequest>,
): UseMutationResult<CreatePdfReferenceResponse, AxiosError, CreatePdfReferenceRequest> {
	return useMutation<CreatePdfReferenceResponse, AxiosError, CreatePdfReferenceRequest>(
		(request) => createPdfReference(request).then((response) => response.data),
		options,
	);
}
